<template>
  <div>
    <div class="header-wrap">
      <div class="header container rm-l-p rm-r-p">
        <router-link to="/">
        <div class="pull-left header-left">
          <a class="logo">
            <img src="../../../assets/img/logo.png" alt="一路牛" height="38">
          </a>
        </div>
        </router-link>
        <div class="pull-right header-right">
          <div class="header-main">
            <div class="header-info pull-right">
              <ul class="header-user pull-right">
                <li class="pull-left">
                  <router-link to="/login">
                    <a class="login">登录</a>
                  </router-link>
                </li>
                <li class="pull-right">
                  <router-link to="/register">
                    <a class="btn btn-org-empty register">免费注册</a>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="headline-bg">
      <div id="waves" class="waves"></div>
    </div>
    <div class="container rm-l-p rm-r-p" id="contents" >
      <div id="main" class="main">
        <p class="close">
        </p>
        <div class="dashboard-func ">
          <div class="pull-left fill">
            <div class="app-fill">
              <span class="select" >找回密码</span>
            </div>
          </div>
        </div>
        <div>
          <section class="pull-left col-sm-10 profile-views">
            <div class="profile-title">
              <el-steps :active="active" align-center finish-status="success">
                <el-step title="发送验证码"></el-step>
                <el-step title="校验手机号"></el-step>
                <el-step title="重置密码"></el-step>
              </el-steps>
            </div>
            <main class="profile-views-main-info">
              <div class="content-nav clearfix" style="margin: auto;width: 350px">
                <div v-if="active===0">
                  <el-form :model="dataForm" ref="sendCodeForm" class="demo-form-inline"
                           label-width="80px" @submit.native.prevent
                  >
                    <el-form-item label="手机号："
                                  prop="phone"
                                  :rules="[
                              { required: true, message: '电话不能为空'},
                              {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '电话格式不正确', trigger: ['blur']}
                            ]"
                    >
                      <el-input v-model="dataForm.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" :loading="sendCodeLoading" @click="sendCode('sendCodeForm')">下一步</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-show="active===1">
                  <el-form :model="dataForm" ref="checkCodeForm" class="demo-form-inline"
                           label-width="80px" @submit.native.prevent
                  >
                    <el-form-item label="验证码："
                                  prop="code"
                                  :rules="[
                              { required: true, message: '验证码不能为空'}
                            ]"
                    >
                      <el-input ref="code" v-model="dataForm.code" placeholder="请输入短信验证码"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" :loading="checkCodeLoading" @click="checkCode('checkCodeForm')">下一步</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-show="active===2">
                  <el-form :model="dataForm" ref="passwordForm" :rules="rules" class="demo-form-inline"
                           label-width="100px" @submit.native.prevent>
                    <el-form-item label="新密码：" prop="password">
                      <el-input ref="password" v-model="dataForm.password" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="passwordCheck">
                      <el-input v-model="dataForm.passwordCheck" placeholder="请再输一遍密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" :loading="passwordLoading" @click="resetPassword('passwordForm')">提交</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </main>
          </section>
        </div>
    </div>
  </div>
  </div>
</template>
<script>
import { sendPasswordCode, checkPasswordCode, resetPassword } from '../../../api/login'
import {Message} from 'element-ui'

export default {
  data: function () {
    var checkPassword = (rule, value, callback) => {
      if (this.wei.isNull(value)) {
        return callback(new Error('密码不能为空'))
      } else if (this.dataForm.password !== value) {
        return callback(new Error('两次密码输入不一样'))
      }
      callback()
    }
    return {
      active: 0,
      sendCodeLoading: false,
      checkCodeLoading: false,
      passwordLoading: false,
      dataForm: {
        phone: '',
        code: '',
        password: '',
        passwordCheck: ''
      },
      userParams: {},
      rules: {
        password: [
          {required: true, message: '密码不能为空'},
          {min: 8, max: 20, message: '长度在 8 到 20 个字之间', trigger: 'blur'}
        ],
        passwordCheck: [
          {validator: checkPassword, required: true, trigger: 'blur'}
        ]
      }
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    sendCode (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendCodeLoading = true
          sendPasswordCode(this.dataForm.phone).then((response) => {
            Message({
              message: response.data.msg,
              type: 'success',
              duration: 5 * 1000
            })
            _this.sendCodeLoading = false
            _this.active = 1
            _this.$nextTick(() => {
              _this.$refs['code'].focus()
              _this.$refs.checkCodeForm.clearValidate()
            })
          }).catch(() => {
            this.dataForm.phone = ''
            this.sendCodeLoading = false
          })
        } else {
          return false
        }
      })
    },
    checkCode (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkCodeLoading = true
          checkPasswordCode(this.dataForm.phone, this.dataForm.code).then((response) => {
            _this.userParams = response.data.data
            _this.checkCodeLoading = false
            _this.active = 2
            _this.$nextTick(() => {
              _this.$refs['password'].focus()
              _this.$refs.passwordForm.clearValidate()
            })
          }).catch(() => {
            this.$refs['code'].focus()
            this.dataForm.code = ''
            this.checkCodeLoading = false
          })
        } else {
          return false
        }
      })
    },
    resetPassword (formName) {
      let _this = this
      _this.$nextTick(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.passwordLoading = true
            this.userParams.password = _this.dataForm.password
            resetPassword(this.userParams).then((response) => {
              _this.active = 3
              Message({
                message: response.data.msg,
                type: 'success',
                duration: 5 * 1000
              })
            }).catch(() => {
              this.dataForm.password = ''
              this.dataForm.passwordCheck = ''
              this.$refs['password'].focus()
              this.$refs['passwordForm'].clearValidate()
              this.passwordLoading = false
            })
          } else {
            return false
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .profile-views
      width 980px
      padding 35px
      background #FBFBFB
      border 1px solid #EEE
      box-shadow 0 0 5px 0 rgba(215,215,215,.5)
      .profile-title
        color #333
        letter-spacing -.63px
        font-size 24px
        line-height 24px
      .profile-views-main-info
        padding 44px 40px 0
        .content-nav
          position relative
          line-height 1
          .text-center
            cursor pointer
</style>
